var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupLayer, LayerGroupLayerManipulation
OCS.Viewer.Functions.define_layer_group_request_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupRequest = {
        request: null,
        init_request_events: function () {
            this.addEvent('init', this.on_request_init.bind(this));
            this.addEvent('post_init', this.on_request_post_init.bind(this));
            this.addEvent('destroy_layer_group', this.destroy_request.bind(this));
        },
        on_request_destroyed: function() {
            this.request = null;
        },
        on_request_init: function () {
            if(this.request) {
                // Since we are initing and we have a pre existing request, we need to destroy it
                this.request.destroy();
            }
            this.get_layer_source();
        },
        on_request_post_init: function () {
            var req = this.get_request();
            req.activate_request();
        },
        subscribe: function () {
            if (!this.is_static()) {
                var req = this.get_request();
                req.set_subscription(true);
            }
        },
        unsubscribe: function () {
            if (!this.is_static()) {
                var req = this.get_request();
                req.set_subscription(false);
            }
        },

        get_layer_source: function (timestamp_epoch) {
            var options = this.get_layer_source_options();
            if (options && !options.metadata.source_type) {
                console.debug('layer_group: missing source type... not even going to bother going any further');
                return;
            }
            var req = this.get_request();
            if (timestamp_epoch) {
                req.add_timestamp_to_request(timestamp_epoch);
            }
        },
        get_request_options: function () {
            var source_options = this.get_layer_source_options();
            var req_ops = Object.clone(source_options);
            req_ops.metadata.layer_name = this.get_layer_name();
            return req_ops;
        },
        get_request: function () {
            if (!this.request) {
                this.request = new OCS.Viewer.Classes.DataSrcMngrDataRequest(this.get_request_options());
                this.request.addEvent('request_destroyed', this.on_request_destroyed.bind(this));
                this.request.addEvent('has_data', this.process_request_success.bind(this));
            }
            return this.request;
        },
        set_request: function (req) {
            this.request = req;
        },
        process_request_success: function (req, src, timestamp) {
            if (src && src.class_type === "Source") {
                this.fireEvent('new_layer_source', [src, timestamp]);
            } else {
                console.error("Missing source!");
            }
            if(this.is_static()) {
                req.destroy();
            }

        },
        destroy_request: function () {
            if (this.request) {
                this.unsubscribe();
                this.request.deactivate_request();
                this.request.destroy();
                this.request = null;
            }
        }
    };
};
OCS.Viewer.Functions.define_layer_group_request_interface();